/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Styled components for SelectDrop
 *
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { select } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';
import { DropDownFilterButtonSize } from '../../DropDownFilter/DropDownFilter';

interface ISelectDrop {
    kind?: string;
    icon?: string;
    iconOpened?: string;
}

export const SelectDropContainerStyled = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    & input {
        display: none;
    }
`;

interface ISelectDropStyledProps extends ISelectDrop, IAttrStyled {
    selectDropSize?: DropDownFilterButtonSize;
}

export const SelectDropStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `select-container select__select-drop-button ${className || ''}`,
    tabIndex: 0,
}))<ISelectDropStyledProps>`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    ${props => props.selectDropSize === DropDownFilterButtonSize.medium ? `
        height: 48px;
        padding-left: 20px;
        padding-right: 44px;
    ` : `
        height: 32px;
        padding-left: 12px;
        padding-right: 32px;
    `};
    border: solid 1px ${select.borderColor};
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    position: relative;
    outline: none;
    user-select: none;

    &.disabled::after {
        opacity: .5;
    }

    &::after {
        display: inline-block;
        content:'';
        ${props => props.selectDropSize === DropDownFilterButtonSize.medium ? `
            width: 32px;
            height: 32px;
        ` : `
            width: 20px;
            height: 20px;
        `};
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        ${(props: ISelectDrop) => props.icon ? `background: url(${props.icon}) no-repeat 50% 50%;`: ''};
        transition: transform 300ms linear;
    }
    &.opened::after {
        ${(props: ISelectDrop) => props.iconOpened ? `background: url(${props.iconOpened}) no-repeat 50% 50%;` :
            'transition: transform 200ms linear; transform: translateY(-50%) rotate(180deg);'
        }
    }

    &.opened,
    &:focus:not(.disabled) {
       border-color: ${select.borderColorFocus};
    }
    &:disabled {
       border-color: ${select.borderColorDisable};
    }

    span {
       opacity: 0.5;
    }
`;
